module.exports = __webpack_public_path__ + "static/media/l.4c67e3b1.webp";